module.exports = __webpack_public_path__ + "img/shangye_jianghuacheng_suoluetu.9959e343.png";